"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLayouts1 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactstrap_1 = require("reactstrap");
// based on sections/CTA/CTA.js
// almost the same except for paragraph classes
var TextLayouts1 = function (_a) {
    var heading = _a.heading, children = _a.children, button = _a.button, link = _a.link;
    return ((0, jsx_runtime_1.jsx)("section", __assign({ className: "section-padding pb-md-11 bg-tertiary" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container text-center" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "row" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "col-md-8 mx-auto" }, { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ className: "lh-1-5 mb-4" }, { children: heading })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "h4 opacity-100 lh-1-75 mb-8" }, { children: children })), (0, jsx_runtime_1.jsx)(reactstrap_1.Button, __assign({ href: link, size: "xl", color: "primary", className: "rounded-pill" }, { children: button }))] })) })) })) })));
};
exports.TextLayouts1 = TextLayouts1;
